import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import useAuth from '../../hooks/useAuth';
import useTheme from '../../hooks/useTheme';

const Login = () => {
    const { login } = useAuth();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        setError('');
        try {
            const user = await login(data.email, data.password);
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.error || 'Error al iniciar sesión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-fondo)' }}>
            <div className="bg-white rounded-2xl shadow-lg p-10 w-full max-w-md">

                {/* Logo y nombre */}
                <div className="flex flex-col items-center mb-8">
                    {theme.empresa_logo ? (
                        <img src={theme.empresa_logo} alt="Logo" className="h-16 mb-3 object-contain" />
                    ) : (
                        <div
                            className="w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-3"
                            style={{ backgroundColor: 'var(--color-primary)' }}
                        >
                            {theme.empresa_nombre?.charAt(0)}
                        </div>
                    )}
                    <h1 className="text-2xl font-bold text-gray-800">{theme.empresa_nombre}</h1>
                    <p className="text-gray-500 text-sm mt-1">Ingresa con tu cuenta</p>
                </div>

                {/* Formulario */}
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Correo electrónico
                        </label>
                        <input
                            type="email"
                            {...register('email', { required: 'El correo es requerido' })}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:border-transparent"
                            style={{ '--tw-ring-color': 'var(--color-primary)' }}
                            placeholder="correo@empresa.com"
                        />
                        {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Contraseña
                        </label>
                        <input
                            type="password"
                            {...register('password', { required: 'La contraseña es requerida' })}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:border-transparent"
                            placeholder="••••••••"
                        />
                        {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
                    </div>

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full text-white font-semibold py-2.5 rounded-lg transition-opacity disabled:opacity-60"
                        style={{ backgroundColor: 'var(--color-primary)' }}
                    >
                        {loading ? 'Ingresando...' : 'Ingresar'}
                    </button>

                    <div className="text-center">
                        <a
                            href="/forgot-password"
                            className="text-sm hover:underline"
                            style={{ color: 'var(--color-primary)' }}
                        >
                            ¿Olvidaste tu contraseña?
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
